
export const get_url = () =>{
    let baseUrl = "https://devapi.plunes.com/insurance"
    const pathLocation = window.location.host;
      if(!!pathLocation) {
            
          if(pathLocation === 'cashless.plunes.com' || pathLocation==="cashlessprod.s3-website.ap-south-1.amazonaws.com") {
            
      // Production baseUrl
            baseUrl = 'https://api.plunes.com/insurance'
                }else{
          baseUrl = "https://devapi.plunes.com/insurance"
      // BaseUrl = 'http://10.5.48.232:3000/api/v1/'
        }
    }
        return baseUrl
  }
  
  export const get_admin_url = () =>{
    let baseUrl = "https://devapi.plunes.com/admin"
    const pathLocation = window.location.host;
      if(!!pathLocation) {
            
          if(pathLocation === 'cashless.plunes.com' || pathLocation ==="cashlessprod.s3-website.ap-south-1.amazonaws.com") {
            
      // Production baseUrl
            baseUrl = 'https://api.plunes.com/admin'
                }else{
          baseUrl = "https://devapi.plunes.com/admin"
      // BaseUrl = 'http://10.5.48.232:3000/api/v1/'
        }
    }
        return baseUrl
  }
  
  export const get_mcm_url = () =>{
    let baseUrl = "https://devapi.plunes.com/mcm"
  
    const pathLocation = window.location.host;
    if(!!pathLocation) {
    // console.log('pathLocation : ', pathLocation);
    // if(pathLocation === 'www.plunes.com' || pathLocation==='https://www.plunes.com/') {
        if(pathLocation === 'www.cashless.plunes.com' || pathLocation==='https://www.cashless.plunes.com/' || pathLocation==='cashless.plunes.com' || pathLocation ==="cashlessprod.s3-website.ap-south-1.amazonaws.com"){
        // if(true){
        // console.log('PROD');
        // Production baseUrl
        baseUrl = 'https://api.plunes.com/mcm'
    }else{
        baseUrl = "https://devapi.plunes.com/mcm"
        // BaseUrl = 'http://10.5.48.232:3000/api/v1/'
    }
    }
    return baseUrl
  }

  export const get_v10_url = () =>{
    let baseUrl = "https://devapi.plunes.com/v10"
    const pathLocation = window.location.host;
      if(!!pathLocation) {
            
          if(pathLocation === 'cashless.plunes.com' || pathLocation ==="cashlessprod.s3-website.ap-south-1.amazonaws.com") {
            
      // Production baseUrl
            baseUrl = 'https://api.plunes.com/v10'
                }else{
          baseUrl = "https://devapi.plunes.com/v10"
      // BaseUrl = 'http://10.5.48.232:3000/api/v1/'
        }
    }
        return baseUrl
  }

  export const is_positive_whole_number = (value) =>{
    if(value===""){
      return true
    }
        if (value.toString().match(/^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/)){
          if(value==='0')
           return false
           return true
        }
        else{
            return false;
        }
  }

  export const get_url_params = (sParam) => {
    let sPageURL = window.location.search.substring(1)
    let sURLVariables = sPageURL.split('&')
    // console.clear()
    // console.log(sURLVariables)
    for (let i = 0; i < sURLVariables.length; i++){
        let sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] == sParam)
        return sParameterName[1]
    }
  }
  
  export const  getTime =(value)=>{
    let currentDate = new Date(value);
    let hour = currentDate.getHours();
    if(hour.toString().length === 1){
      hour = `0${hour}`
    }
   
    let minutes = currentDate.getMinutes();
    if(minutes.toString().length === 1){
      minutes = `0${minutes}`
    }
    
    return  (hour) + ":" + minutes;
  }

  export const  getDateFormat =(value)=>{
    let currentDate = new Date(value);
    let date = currentDate.getDate();
    let month = currentDate.getMonth();
    let year = currentDate.getFullYear();
    if(date < 10)
      date = "0" + date
    month = month + 1
    if(month < 10)
      month = "0" + month
    return date + "/" + month + "/" + year;
  }